import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";

function ProjectCards(props) {
  const links = props.links && props.links.length > 0
    ? props.links
    : props.link
      ? [{ label: props.isBlog ? "View Blog" : "View Project", url: props.link }]
      : [];

  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt={`${props.title} preview`} />
      <Card.Body className="project-card-body">
        {props.deliverables && props.deliverables.length > 0 && (
          <div className="project-deliverables">
            {props.deliverables.map((item, index) => (
              <span key={index} className="project-deliverable-pill">
                {item}
              </span>
            ))}
          </div>
        )}
        <Card.Title className="project-title">{props.title}</Card.Title>
        <Card.Text className="project-tech purple">
          {props.technologyUsed}
        </Card.Text>
        <Card.Text className="project-description">
          {props.description}
        </Card.Text>
        {links.length > 0 && (
          <div className="project-links">
            {links.map((item, index) => (
              <Button
                key={index}
                variant={index === 0 ? "primary" : "primary"}
                href={item.url}
                target="_blank"
                rel="noreferrer"
                className="project-link-btn download-button"
              >
                <BiLinkExternal /> &nbsp;{item.label}
              </Button>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
